import { dataHooks } from '@wix/data-hooks';

export const sectionDataHooks = dataHooks<{
  articles;
  helpCenter;
  resources;
  hirePartner;
  contactUs;
  statusPage;
  chatWithUs;
  userContacts;
  feedback;
  requestSuccessManager;
}>('homepageSectionDataHooks');
